import { Box, ScrollArea, Table, Text, UnstyledButton } from '@mantine/core';
import { IProdoqMenuResponse } from '../../../../../../shared/types/prodoq';

interface PermissionMenuTableProps {
  menus: IProdoqMenuResponse[];
  selectedMenuId: number | null;
  onSelectMenuId: (menuId: number) => void;
}

const ROW_HEIGHT = 56;

function getMenuLabel(menu: IProdoqMenuResponse) {
  if (menu.id === 7 || menu.id === 8) {
    return `${menu.menuName} (마스터만 가능)`;
  }

  return menu.menuName;
}

export default function PermissionMenuTable(props: PermissionMenuTableProps) {
  const { menus, selectedMenuId, onSelectMenuId } = props;

  return (
    <Box
      flex={1}
      style={{
        display: 'flex',
      }}
    >
      <ScrollArea h="100%" type="auto" offsetScrollbars style={{ flex: 1 }}>
        <Table stickyHeader withTableBorder withColumnBorders highlightOnHover={false}>
          <Table.Thead>
            <Table.Tr bg="blue.0">
              <Table.Th ta="center">1차 메뉴</Table.Th>
              <Table.Th ta="center">2차 메뉴</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {[...menus]
              .sort((a, b) => a.order - b.order)
              .map((menu) => {
                const children = [...menu.children].sort((a, b) => a.order - b.order);

                if (children.length === 0) {
                  const isSelected = selectedMenuId === menu.id;

                  return (
                    <Table.Tr key={menu.id}>
                      <Table.Td p={0}>
                        <UnstyledButton
                          onClick={() => onSelectMenuId(menu.id)}
                          style={{
                            width: '100%',
                            minHeight: `${ROW_HEIGHT}px`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 16px',
                            backgroundColor: isSelected ? '#e6ebf2' : '#fff',
                            cursor: 'pointer',
                          }}
                        >
                          <Text size="sm" ta="center" fw={isSelected ? 700 : 500} c={isSelected ? '#1f2937' : '#111827'}>
                            {getMenuLabel(menu)}
                          </Text>
                        </UnstyledButton>
                      </Table.Td>
                      <Table.Td />
                    </Table.Tr>
                  );
                }

                return children.map((child, index) => {
                  const isSelected = selectedMenuId === child.id;

                  return (
                    <Table.Tr key={child.id}>
                      {index === 0 && (
                        <Table.Td rowSpan={children.length} p={0} style={{ verticalAlign: 'middle' }}>
                          <Box
                            style={{
                              width: '100%',
                              height: '100%',
                              minHeight: `${children.length * ROW_HEIGHT}px`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0 16px',
                              backgroundColor: '#fff',
                            }}
                          >
                            <Text size="sm" ta="center" fw={500} c="#111827">
                              {getMenuLabel(menu)}
                            </Text>
                          </Box>
                        </Table.Td>
                      )}
                      <Table.Td p={0}>
                        <UnstyledButton
                          onClick={() => onSelectMenuId(child.id)}
                          style={{
                            width: '100%',
                            minHeight: `${ROW_HEIGHT}px`,
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0 18px 0 24px',
                            backgroundColor: isSelected ? '#e6ebf2' : '#fff',
                            cursor: 'pointer',
                          }}
                        >
                          <Text
                            size="sm"
                            fw={isSelected ? 700 : 500}
                            c={isSelected ? '#1f2937' : '#111827'}
                            style={{
                              lineHeight: 1.4,
                              wordBreak: 'keep-all',
                            }}
                          >
                            {getMenuLabel(child)}
                          </Text>
                        </UnstyledButton>
                      </Table.Td>
                    </Table.Tr>
                  );
                });
              })}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Box>
  );
}
